import { render, staticRenderFns } from "./LoadingScreen.vue?vue&type=template&id=c3190840&"
import script from "./LoadingScreen.vue?vue&type=script&lang=js&"
export * from "./LoadingScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3190840')) {
      api.createRecord('c3190840', component.options)
    } else {
      api.reload('c3190840', component.options)
    }
    module.hot.accept("./LoadingScreen.vue?vue&type=template&id=c3190840&", function () {
      api.rerender('c3190840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Register/components/LoadingScreen.vue"
export default component.exports